import { render, staticRenderFns } from "./LabEnthalpyEntropyOfBorax.vue?vue&type=template&id=4af47674&"
import script from "./LabEnthalpyEntropyOfBorax.vue?vue&type=script&lang=ts&"
export * from "./LabEnthalpyEntropyOfBorax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports